export default __webpack_public_path__ + "static/media/partnerv5.f64f2980.mp4";